import React from "react";
import { ThemeProvider } from "styled-components";

const theme = {
  color: {
    primary: "#862F2F",
    secondary: "#999999",
    dark: "#333333", 
    bright: "#FFFFFF"
  },
  font: {
    primary: "'Copperplate', serif",
    secondary: "'Open Sans', serif"
  },
  fontSize: {
    xxs: "0.7rem",
    xs: "0.85rem",
    sm: "1em",
    md: "1.2em",
    ml: "1.5em",
    lg: "2rem",
    xl: "3rem",
    xxl: "4rem",
  }
};



const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;